<script setup lang="ts">
const props = defineProps({
  submittedDocumentId: {
    type: String,
    required: true,
  },
  classroomId: {
    type: String,
    required: true,
  },
  studentId: {
    type: String,
    required: true,
  },
});

const submittedDocumentStore = useSubmittedDocumentStore(
  props.submittedDocumentId
);

const documentViewModeStore = useDocumentViewMode(props.submittedDocumentId)();
const { isReviewMode } = storeToRefs(documentViewModeStore);

const classroomDataStore = useStudentClassroomData(
  useCurrentUID()!,
  props.studentId
)();

const { classroomFromId } = storeToRefs(classroomDataStore);

onMounted(() => {
  classroomDataStore.initializeStudentClassroomData();
});

const canShowButton = computed(() => {
  if (isReviewMode.value == true) {
    return false;
  }

  return true;
});
</script>

<template>
  <BaseOutlinedButton
    v-if="canShowButton"
    @click="submittedDocumentStore.setIsEditingMode(true)"
    class="w-full mb-4"
    color="secondary"
  >
    <div class="flex flex-row items-center gap-2">
      <BaseIconEdit />
      <span>Edit Submission</span>
    </div>
  </BaseOutlinedButton>
</template>

<style scoped></style>
